// import { lazy } from 'react';
import {
  TeamOutlined,
  PieChartOutlined,
  ReadOutlined,
  UserOutlined,
  QuestionCircleOutlined,
    UserAddOutlined
} from "@ant-design/icons";

// project imports
// import Loadable from "components/Loadable"
import AdminLayout from "layout/AdminLayout";
import Dashboard from "page/Dashboard";

import Quotes from "page/Quotes";
import QuotesAdd from "page/Quotes/Add";
import QuotesEdit from "page/Quotes/Edit";
import QuotesView from "page/Quotes/View";

import Authors from "page/Authors";
import AuthorAdd from "page/Authors/Add";
import AuthorEdit from "page/Authors/Edit";
import AuthorView from "page/Authors/View";

import Topics from "page/Topics";
import TopicAdd from "page/Topics/Add";
import TopicEdit from "page/Topics/Edit";
import TopicView from "page/Topics/View";

import ScrapingAdd from "page/Scraping/Add";
// import ScrapingAddIframe from "page/Scraping/AddIframe";
import ScrapingConfirm from "page/Scraping/Confirm";

import Users from "page/Users";
import AuthGuard from "./AuthGuard"

// const Login = Loadable(lazy(() => import('page/Auth/Login')));

export const adminMenu = [
  {
    menu: true,
    path: "/",
    roles: ["admin"],
    label: "Dashboard",
    icon: <PieChartOutlined />,
  },
  {
    menu: true,
    path: "/quotes",
    roles: ["admin"],
    label: "Quotes",
    icon: <ReadOutlined />,
  },
  {
    path: "/quotes/add",
    roles: ["admin"],
    label: "Quotes",
  },
  {
    path: "/quotes/edit/:id",
    roles: ["admin"],
    label: "Quotes",
  },
  {
    menu: true,
    path: "/topics",
    roles: ["admin"],
    label: "Topics",
    icon: <QuestionCircleOutlined />,
  },
  {
    menu: true,
    path: "/authors",
    roles: ["admin"],
    label: "Authors",
    icon: <UserOutlined />,
  },
  {
    menu: true,
    path: "/users",
    roles: ["admin"],
    label: "Users",
    icon: <TeamOutlined />,
    // key: "submenu",
    // children: [
    //   {
    //     key: "user-add",
    //     path: "/users/add",
    //     roles: ["admin"],

    //     label: "Add User",

    //     icon: <UserAddOutlined />,
    //   },
    // ],
  },
  {
    menu: true,
    // path: "/users",
    roles: ["admin"],
    label: "Scraping",
    icon: <TeamOutlined />,
    key: "submenu",
    children: [
      {
        key: "scraping-url-add",
        path: "/scraping/url",
        roles: ["admin"],
        label: "Add By URL",
        icon: <UserAddOutlined />,
      },
      // {
      //   key: "scraping-iframe-add",
      //   path: "/scraping/iframe",
      //   roles: ["admin"],
      //   label: "Add By Iframe",
      //   icon: <UserAddOutlined />,
      // },
    ],
  },
];

const AdminRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  // children: adminMenu
  children: [
    {
      path: "/",
      element: <Dashboard />,
    },
    {
      path: "/quotes",
      element: <Quotes />,
    },
    {
      path: "/quotes/add",
      element: <QuotesAdd />,
    },
    {
      path: "/quotes/edit/:id",
      element: <QuotesEdit />,
    },
    {
      path: "/quotes/view/:id",
      element: <QuotesView />,
    },
    {
      path: "/authors",
      element: <Authors />,
    },
    {
      path: "/authors/add",
      element: <AuthorAdd />,
    },
    {
      path: "/authors/edit/:id",
      element: <AuthorEdit />,
    },
    {
      path: "/authors/view/:id",
      element: <AuthorView />,
    },
    {
      path: "/topics",
      element: <Topics />,
    },
    {
      path: "/topics/add",
      element: <TopicAdd />,
    },
    {
      path: "/topics/edit/:id",
      element: <TopicEdit />,
    },
    {
      path: "/topics/view/:id",
      element: <TopicView />,
    },
    {
      path: "/users",
      element: <Users />,
    },
    {
      path: "/scraping/url",
      element: <ScrapingAdd />,
    },
    // {
    //   path: "/scraping/iframe",
    //   element: <ScrapingAddIframe />,
    // },
    {
      path: "/scraping/confirm",
      element: <ScrapingConfirm />,
    },
  ],
};

export default AdminRoutes;
